import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { QStatsComponent } from './q-stats.component';
import { TranslateModule } from '@xref/ngx';
import { CategoryIconModule } from 'src/app/components/category-icon/category-icon.module';
import { MatGridListModule } from '@angular/material/grid-list';
import { MatTooltipModule } from '@angular/material/tooltip';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';

@NgModule({
  declarations: [QStatsComponent],
  imports: [
    CommonModule,
    TranslateModule,
    CategoryIconModule,
    MatGridListModule,
    FontAwesomeModule,
    MatTooltipModule
  ],
  exports: [QStatsComponent],
})
export class QStatsModule {}
